import React, { useContext, useCallback } from 'react';

import { CuiIntegrationsSettings } from '../../../../connection-components/integrations-settings';
import { enums } from '../constants';
import { IntegrationsContext } from '../context';
import style from '../style.module.less';

const Settings = () => {
  const { fetchIntegrations, sellerStores } = useContext(IntegrationsContext);
  const handleMailChimpDeletion = useCallback(() => fetchIntegrations(), [fetchIntegrations]);

  const MailChimpAppId = enums.mailchimp;

  return (
    <div className={style['cui-container']}>
      <CuiIntegrationsSettings integrationAppId={MailChimpAppId} onDelete={handleMailChimpDeletion} sellerStores={sellerStores} />
    </div>
  );
};

export default Settings;
